import {Space} from "antd";
import {SubSettingsFormFields} from "../../general/settings/sub-settings";
import {PURCHASE_LIMIT_LABEL} from "../../general/settings/sub-settings/purchase-limit";

export function ServiceSettingsFormFields({
  showUrlRedirect = true,
}: {
  showUrlRedirect?: boolean;
} = {}) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <SubSettingsFormFields
        requestCustomerPhoneNumberLabel="Request customer's phone number"
        hideFromProfileLabel="Hide service from your profile page "
        purchaseLimitLabel={PURCHASE_LIMIT_LABEL}
        showUrlRedirect={showUrlRedirect}
      />
    </Space>
  );
}
